import React, { useEffect, useState } from "react";
import {
    CRow, CCol, CCardBody, CCard, CButton, CFormInput, CCardHeader, CNav, CNavItem, CNavLink,
    CDropdown,
    CDropdownToggle,
    CDropdownItem,
    CDropdownMenu,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CBadge,
    CSpinner,
} from '@coreui/react';
import { toast } from 'react-toastify';
import { cibAdobe, cibMicrosoft, cilFile, cilCheckCircle, cilXCircle } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CListGroup, CListGroupItem } from '@coreui/react';
import { useParams, useNavigate } from 'react-router-dom';
import { AssesmentRepository } from "src/repositories/assessmentRepository";
import Responses from './Responses';
import Curated from './Curated';
import Discarded from "./Discarded";
import Details from "./Details";
import { IaApiClient } from "src/network/iaApiClient";
import CustomButton from "src/components/CustomButton";
var cleanedAssessmentId;

const assesmentPage = () => {
    const { assessmentId, orgId } = useParams();
    const navigate = useNavigate();
    const [questions, setQuestions] = useState([]);
    const [assessmentName, setAssessmentName] = useState('');
    const [activeTab, setActiveTab] = useState('details');
    const [projectId, setProjectId] = useState('');
    const [initialDesc, setInitialDesc] = useState('');
    const [editedDesc, setEditedDesc] = useState('');
    const [initialFiles, setInitialFiles] = useState([]);
    const [editedFiles, setEditedFiles] = useState([]);
    const [tempFiles, setTempFiles] = useState([]);
    const [isPageLoading, setIsPageLoading] = useState(true);
    const [verifiedResponsesCount, setVerifiedResponsesCount] = useState(null);
    const [showPrepareDataModal, setShowPrepareDataModal] = useState(false)
    const [showGenerateReportModal, setShowGenerateReportModal] = useState(false)
    const [totalResponses, setTotalResponses] = useState(0);
    const [dataReadyStatus, setDataReadyStatus] = useState(null);
    const [reportStatus, setReportStatus] = useState(null);
    const pollingIntervalRef = React.useRef(null);
    const reportPollingIntervalRef = React.useRef(null);
    const [dataLoaded, setDataLoaded] = useState(false);


    useEffect(() => {
        const cleanId = cleanProjectId(assessmentId);
        cleanedAssessmentId = cleanId;
        const loadData = async () => {
            await getassessmentDetailsById();
            await getVerifiedResponsesCount();
            
            // Only fetch status if not in terminal states
            if (dataReadyStatus && dataReadyStatus !== 'COMPLETED' && dataReadyStatus !== 'FAILED') {
                await checkDataPrepStatus();
            }
            if (reportStatus && reportStatus !== 'GENERATED' && reportStatus !== 'FAILED') {
                await checkReportStatus();
            }
            
            setDataLoaded(true);
        };
        loadData();

        // Cleanup function to abort polling when navigating away
        return () => {
            if (pollingIntervalRef.current) {
                clearInterval(pollingIntervalRef.current);
                pollingIntervalRef.current = null;
            }
            if (reportPollingIntervalRef.current) {
                clearInterval(reportPollingIntervalRef.current);
                reportPollingIntervalRef.current = null;
            }
        };
    }, [assessmentId]);

    useEffect(() => {
        // Start polling based on current status
        if (dataLoaded) {
            // Poll for data preparation if status is QUEUED or IN_PROGRESS
            if ((dataReadyStatus === 'QUEUED' || dataReadyStatus === 'IN_PROGRESS') && !pollingIntervalRef.current) {
                startPollingDataPreparation();
            }
            
            // Poll for report generation if status is QUEUED or IN_PROGRESS
            if ((reportStatus === 'QUEUED' || reportStatus === 'IN_PROGRESS') && !reportPollingIntervalRef.current) {
                startPollingReportGeneration();
            }
        }
    }, [dataLoaded, dataReadyStatus, reportStatus]);

    const cleanProjectId = (id) => {
        if (!id.includes('&')) {
            return id;
        }
        const parts = id.split('&');
        return parts[0]; // Return only the part before the first '&'
    };

    const getassessmentDetailsById = async () => {
        try {
            const assesmentDetails = await AssesmentRepository.getAssessmentDetailsById(cleanedAssessmentId);
            const data = assesmentDetails.data[0];
            setIsPageLoading(false);
            setQuestions(data.questions);
            setAssessmentName(data.assessment_name);
            setInitialDesc(data.description);
            setEditedDesc(data.description);
            setInitialFiles(data.supported_document.map(url => ({ url, key: url.split('/').pop().split('?')[0] })));
            setEditedFiles(data.supported_document.map(url => ({ url, key: url.split('/').pop().split('?')[0] })));
            setProjectId(data.project_id);
            
            // Set status from assessment data
            setDataReadyStatus(data.data_ready_status);
            setReportStatus(data.report_status);
        }
        catch (error) {
            console.error('Error', error);
        }
    }

    const getVerifiedResponsesCount = async () => {
        try {
            const response = await AssesmentRepository.getCuratedResponses(cleanedAssessmentId);
            const count = response.data?.length || 0;
            setVerifiedResponsesCount(count);
        } catch (error) {
            console.error('Error retrieving verified responses count:', error);
        }
    }

    const truncate = (text, limit) => {
        return text?.length > limit ? text.substring(0, limit) + '...' : text;
    };

    const notify = (message) => toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
    const notifyInfo = (message) => toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });

    const getFileIcon = (fileExtension) => {
        switch (fileExtension?.toLowerCase()) {
            case 'pdf':
                return cibAdobe;
            case 'doc':
            case 'docx':
                return cibMicrosoft;
            case 'txt':
                return cilFile;
            default:
                return cilFile;
        }
    };

    const handleDescChange = (e) => {
        setEditedDesc(e.target.value);
    };

    // const handleSaveDesc = async () => {
    //     const body = {
    //         description: editedDesc
    //     }
    //     try {
    //         const res = await AssesmentRepository.updateAssessmentDetails(cleanedAssessmentId, body);
    //         console.log(res);
    //         setAssessmentDesc(editedDesc);
    //     } catch {
    //         console.error('Failed to update description');
    //     }
    // };

    const handleFileChange = async (e) => {
        const maxFiles = 3; // Maximum number of files allowed
        const selectedFiles = Array.from(e.target.files).filter(file =>
            ['application/msword', 'text/plain', 'application/pdf'].includes(file.type)
        ).map(file => ({
            file,
            status: 'pending',
            url: '',
            key: '',
        }));

        const totalFiles = editedFiles?.length + selectedFiles?.length;

        if (totalFiles > maxFiles) {
            notify(`You can only upload up to ${maxFiles} files.`);
            console.error(`You can only upload up to ${maxFiles} files.`);
            return;
        }

        const limitedFiles = selectedFiles.slice(0, maxFiles - editedFiles?.length);
        const uploadedFiles = await uploadFiles(limitedFiles);
        setEditedFiles(prevFiles => [...prevFiles, ...uploadedFiles]);
        // await updateAssessmentFiles([...files, ...uploadedFiles].map(f => f.url));
    };

    const uploadFiles = async (files) => {
        const uploadedFiles = [];
        for (const fileObj of files) {
            const formData = new FormData();
            formData.append('file', fileObj.file);
            try {
                const response = await IaApiClient.upload('assessment/upload', formData);
                uploadedFiles.push({ ...fileObj, status: 'uploaded', url: response.data.url, key: response.data.key });
            } catch (error) {
                console.error('Error uploading file:', fileObj.file.name, error);
            }
        }
        return uploadedFiles;
    };

    const checkDataPrepStatus = async () => {
        try {
            const response = await AssesmentRepository.getDataPreperationStatus(cleanedAssessmentId);
            const status = response.status;
            setDataReadyStatus(status);
        } catch (error) {
            console.error('Error checking data preparation status:', error);
        }
    };

    const checkReportStatus = async () => {
        try {
            const response = await AssesmentRepository.getReportStatus(cleanedAssessmentId);
            const status = response.status;
            setReportStatus(status);
        } catch (error) {
            console.error('Error checking report generation status:', error);
        }
    };

    const handlePrepareData = async () => {
        try {
            await AssesmentRepository.prepareDataForReportGeneration(cleanedAssessmentId);
            setShowPrepareDataModal(false);
            setDataReadyStatus('QUEUED');
            notifyInfo('Data preparation started. This may take a few minutes...');
            startPollingDataPreparation();
        } catch (error) {
            notify('Failed to start data preparation');
            console.error(error);
        }
    };

    const startPollingDataPreparation = () => {
        // Clear any existing interval first
        if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
        }
        
        const interval = setInterval(async () => {
            try {
                const response = await AssesmentRepository.getDataPreperationStatus(cleanedAssessmentId);
                const status = response.status;
                setDataReadyStatus(status);
                
                if (status === 'COMPLETED') {
                    clearInterval(pollingIntervalRef.current);
                    pollingIntervalRef.current = null;
                    notifyInfo('Data preparation completed! You can now generate the report.');
                } else if (status === 'FAILED') {
                    clearInterval(pollingIntervalRef.current);
                    pollingIntervalRef.current = null;
                    notify('Data preparation failed. Please try again.');
                }
            } catch (error) {
                console.error('Error polling data preparation status:', error);
            }
        }, 5000); // Poll every 5 seconds
        
        pollingIntervalRef.current = interval;
    };

    const startPollingReportGeneration = () => {
        if (reportPollingIntervalRef.current) {
            clearInterval(reportPollingIntervalRef.current);
            reportPollingIntervalRef.current = null;
        }
        
        const interval = setInterval(async () => {
            try {
                const response = await AssesmentRepository.getReportStatus(cleanedAssessmentId);
                const status = response.status;
                setReportStatus(status);
                
                if (status === 'GENERATED') {
                    clearInterval(reportPollingIntervalRef.current);
                    reportPollingIntervalRef.current = null;
                    notifyInfo('Report generation completed! Redirecting to dashboard...');
                    setTimeout(() => {
                        navigate(`/dashboard/${cleanedAssessmentId}`);
                    }, 2000);
                } else if (status === 'FAILED') {
                    clearInterval(reportPollingIntervalRef.current);
                    reportPollingIntervalRef.current = null;
                    notify('Report generation failed. Please try again.');
                }
            } catch (error) {
                console.error('Error polling report generation status:', error);
            }
        }, 5000);
        
        reportPollingIntervalRef.current = interval;
    };

    const handleGenerateReport = async () => {
        try {
            await AssesmentRepository.createReport(cleanedAssessmentId);
            setShowGenerateReportModal(false);
            setReportStatus('QUEUED');
            notifyInfo('Report generation started. This may take a few minutes...');
            startPollingReportGeneration();
        } catch (error) {
            notify('Failed to start report generation');
            console.error(error);
        }
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'details':
                return <Details editedDesc={editedDesc} editedFiles={editedFiles} verifiedResponsesCount={verifiedResponsesCount}></Details>
            case 'responses':
                return <Responses setVerifiedResponsesCount={setVerifiedResponsesCount} verifiedResponsesCount={verifiedResponsesCount} getVerifiedResponsesCount={getVerifiedResponsesCount} setTotalResponses={setTotalResponses} projectId={projectId} assessmentId={cleanedAssessmentId} selectedOrg={orgId}></Responses>;
            case 'curatedResponses':
                return <Curated projectId={projectId} assessmentId={cleanedAssessmentId}></Curated>;
            case 'discarded':
                return <Discarded projectId={projectId} assessmentId={cleanedAssessmentId}></Discarded>;
            default:
                return null; // Return null if no tab is selected
        }
    };

    return (
        <>
            {isPageLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                    <CSpinner className='spinner' />
                </div>
            ) : (
                <>
                    <CCard className="assessment-verify-card" style={{ position: 'relative', overflow: 'hidden' }}>
                        <CCardHeader className="title ellipsis" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                            <span>{assessmentName}</span>
                        </CCardHeader>
                        <CCardBody>
                            <h5 >Questions:</h5>
                            <CListGroup>
                                {questions && questions.map((question) => (
                                    <CListGroupItem key={question.q_id} className="d-flex align-items-center flexgap1 questions-background">
                                        <div>
                                            <strong>Q{question.sequence_no}.</strong> {question.q_text}
                                        </div>
                                        {question.q_type === "Multiple Choice" && (
                                            <CDropdown direction="center">
                                                <CDropdownToggle size="sm" color="secondary">
                                                    Multiple Choice
                                                    <span style={{ marginLeft: "3px", color: 'var(--primary)' }}>▼</span>
                                                </CDropdownToggle>
                                                <CDropdownMenu>
                                                    {question.options && question.options.map((option, index) => (
                                                        <CDropdownItem key={index}>
                                                            {option}
                                                        </CDropdownItem>
                                                    ))}
                                                </CDropdownMenu>
                                            </CDropdown>
                                        )}
                                    </CListGroupItem>
                                ))}
                            </CListGroup>
                        </CCardBody>
                    </CCard>

                    <CCard className='assessment-verify-card' style={{ marginTop: "1rem", minHeight: "30rem", position: "relative", paddingBottom: "5rem" }}>
                        <CCardBody>
                            <CNav variant="tabs" className="sub-tabs">
                                <CNavItem>
                                    <CNavLink
                                        active={activeTab === 'details'}
                                        onClick={() => setActiveTab('details')}
                                        className={`pointer ${activeTab === 'details' ? 'active-tab' : ''}`}
                                    >
                                        Details
                                    </CNavLink>
                                </CNavItem>
                                <CNavItem>
                                    <CNavLink
                                        active={activeTab === 'responses'}
                                        onClick={() => setActiveTab('responses')}
                                        className={`pointer ${activeTab === 'responses' ? 'active-tab' : ''}`}
                                    >
                                        Unverified
                                    </CNavLink>
                                </CNavItem>
                                <CNavItem>
                                    <CNavLink
                                        active={activeTab === 'curatedResponses'}
                                        onClick={() => setActiveTab('curatedResponses')}
                                        className={`pointer ${activeTab === 'curatedResponses' ? 'active-tab' : ''}`}
                                    >
                                        Verified
                                    </CNavLink>
                                </CNavItem>
                                <CNavItem>
                                    <CNavLink
                                        active={activeTab === 'discarded'}
                                        onClick={() => setActiveTab('discarded')}
                                        className={`pointer ${activeTab === 'discarded' ? 'active-tab' : ''}`}
                                    >
                                        Rejected
                                    </CNavLink>
                                </CNavItem>
                            </CNav>
                            <CRow className="mt-4">
                            {activeTab ? (
                                    <CCol>
                                        {renderContent()}
                                    </CCol>
                                ) : null}
                            </CRow>
                            <div style={{
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                right: 0,
                                padding: "1rem",
                                display: "flex",
                                gap: "1rem",
                                backgroundColor: "#252525",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                zIndex: 1000
                            }}>
                                {/* Prepare Data Button - Only show if not COMPLETED */}
                                {dataReadyStatus !== 'COMPLETED' && (
                                    <CustomButton
                                        onClick={() => setShowPrepareDataModal(true)}
                                        disabled={
                                            verifiedResponsesCount < 30 ||
                                            dataReadyStatus === 'QUEUED' ||
                                            dataReadyStatus === 'IN_PROGRESS'
                                        }
                                    >
                                        {dataReadyStatus === 'QUEUED' || dataReadyStatus === 'IN_PROGRESS' ? (
                                            <>
                                                <CSpinner size="sm" style={{ marginRight: '0.5rem' }} />
                                                Preparing Data...
                                            </>
                                        ) : dataReadyStatus === 'FAILED' ? (
                                            <>
                                                <CIcon icon={cilXCircle} size="sm" style={{ marginRight: '0.5rem' }} />
                                                Data Preparation Failed
                                            </>
                                        ) : (
                                            'Prepare Data for Report'
                                        )}
                                    </CustomButton>
                                )}

                                {/* Data Ready Indicator and Generate Report Button */}
                                {dataReadyStatus === 'COMPLETED' && (
                                    <>
                                        {reportStatus !== 'GENERATED' && <div style={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            gap: '0.5rem',
                                            color: '#4ade80',
                                            fontSize: '0.9rem'
                                        }}>
                                            <CIcon icon={cilCheckCircle} size="lg" />
                                            <span>Data is Ready</span>
                                        </div>}
                                        
                                        {reportStatus === 'GENERATED' ? (
                                            <CustomButton
                                                onClick={() => navigate(`/dashboard/${cleanedAssessmentId}`)}
                                            >
                                                View Report
                                            </CustomButton>
                                        ) : (
                                            <CustomButton
                                                onClick={() => setShowGenerateReportModal(true)}
                                                disabled={reportStatus === 'QUEUED' || reportStatus === 'IN_PROGRESS'}
                                            >
                                                {reportStatus === 'QUEUED' || reportStatus === 'IN_PROGRESS' ? (
                                                    <>
                                                        <CSpinner size="sm" style={{ marginRight: '0.5rem' }} />
                                                        Generating Report...
                                                    </>
                                                ) : reportStatus === 'FAILED' ? (
                                                    <>
                                                        <CIcon icon={cilXCircle} size="sm" style={{ marginRight: '0.5rem' }} />
                                                        Report Generation Failed
                                                    </>
                                                ) : (
                                                    'Generate Report'
                                                )}
                                            </CustomButton>
                                        )}
                                    </>
                                )}
                            </div>
                        </CCardBody>
                    </CCard>
                </>
            )}
            <CModal
                visible={showPrepareDataModal}
                onClose={() => setShowPrepareDataModal(false)}
                aria-labelledby="PrepareDataModal"
            >
                <CModalHeader onClose={() => setShowPrepareDataModal(false)}>
                    <CModalTitle id="PrepareDataModal">Prepare Data for Report</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <p>Are you sure you want to prepare the data for report generation? You have verified {verifiedResponsesCount} responses.</p>
                    <p>This process may take a few minutes.</p>
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" onClick={() => setShowPrepareDataModal(false)}>
                        Close
                    </CButton>
                    <CButton onClick={() => handlePrepareData()} color="primary">
                        Yes, Prepare Data
                    </CButton>
                </CModalFooter>
            </CModal>
            <CModal
                visible={showGenerateReportModal}
                onClose={() => setShowGenerateReportModal(false)}
                aria-labelledby="GenerateReportModal"
            >
                <CModalHeader onClose={() => setShowGenerateReportModal(false)}>
                    <CModalTitle id="GenerateReportModal">Generate Report</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <p>Data preparation is complete. Would you like to generate the report now?</p>
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" onClick={() => setShowGenerateReportModal(false)}>
                        Close
                    </CButton>
                    <CButton onClick={() => handleGenerateReport()} color="primary">Yes, Generate Report</CButton>
                </CModalFooter>
            </CModal>
        </>
    );
};

export default assesmentPage;
